import RepairableObject from "../RepairableObject";
import {SPARE_PARTS_TYPES} from "../../../constants/Constants";

class BaseLocomotive extends RepairableObject
{
    constructor(parentStation, id, state, type)
    {
        super(id, state);
        this.type = type;
        this.isHot = false;
        this.partsType = SPARE_PARTS_TYPES[type];
        this.hasBrigade = false;
        this.isOnTrain = false;
        this.parentStation = parentStation;
    }

}
export default BaseLocomotive;